import { CYPRESS_ID_ATTRIBUTE } from 'src/common/constants';

export const setCypressID = (cypressID: string | undefined) => ({
    [CYPRESS_ID_ATTRIBUTE]: cypressID,
});
